var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "load-div" },
          [_c("b-spinner", { attrs: { variant: "primary" } })],
          1
        )
      : _c(
          "div",
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-9" }, [
                _c("h4", { staticClass: "text-primary d-flex flex-column" }, [
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v("Nombre del flujo: "),
                    _c("b", [_vm._v(_vm._s(_vm.data.aprobacion.nombre))])
                  ]),
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v("Doc. Referencia: "),
                    _c("b", [_vm._v(_vm._s(_vm.getDocRef()))])
                  ]),
                  _c("span", { staticClass: "mb-2" }, [
                    _vm._v("Unidad: "),
                    _c("b", [_vm._v(_vm._s(_vm.getUnitName()))])
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-end align-items-start mb-5"
                  },
                  [
                    _c(
                      "vs-button",
                      {
                        attrs: { variant: "primary", icon: "arrow_back" },
                        on: { click: _vm.backToList }
                      },
                      [_vm._v(" Volver ")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _c("div", { staticClass: "row height" }, [
              _c(
                "div",
                { staticClass: "col-12 mb-4 info" },
                [
                  _vm.forms.consequences ? _c("ConsequencesInfo") : _vm._e(),
                  _vm.forms.observers ? _c("ObserversInfo") : _vm._e(),
                  _vm.forms.steps ? _c("StepsInfo") : _vm._e()
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-9" },
                [
                  _c("FlowDetail", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.forms.flowDetail,
                        expression: "forms.flowDetail"
                      }
                    ],
                    attrs: { tipoOficina: _vm.data.aprobacion.tipoOficina },
                    on: { flowDetail: _vm.setFlowDetail }
                  }),
                  _c("Observers", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.forms.observers,
                        expression: "forms.observers"
                      }
                    ],
                    on: { observers: _vm.addObservers }
                  }),
                  _c(
                    "b-card",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.forms.consequences,
                          expression: "forms.consequences"
                        }
                      ],
                      staticClass: "scroll",
                      attrs: { title: "Consecuencias" }
                    },
                    [
                      _c("Consequences", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.forms.consequences,
                            expression: "forms.consequences"
                          }
                        ],
                        attrs: {
                          reference: _vm.data.aprobacion.tipoObjeto,
                          original: _vm.aprovalTemplate.gatillaciones
                        },
                        on: { consequences: _vm.addConsequences }
                      })
                    ],
                    1
                  ),
                  _c("Steps", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.forms.steps,
                        expression: "forms.steps"
                      }
                    ],
                    attrs: {
                      errorOnSave: _vm.errorOnSave,
                      flowType: _vm.data.aprobacion.tipoEjecucion,
                      examplePdf:
                        _vm.aprovalTemplate && _vm.aprovalTemplate.aprobacion
                          ? _vm.aprovalTemplate.aprobacion.pdfEjemplo
                          : null,
                      reference: _vm.data.aprobacion.tipoObjeto
                    },
                    on: {
                      steps: function($event) {
                        _vm.data.pasos = $event
                      },
                      "set-office-type": _vm.setOfficeType,
                      filePreview: function($event) {
                        _vm.data.filePreview = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("TemplatePartsButtons", {
                    attrs: {
                      saveData: _vm.saveData,
                      data: _vm.data,
                      forms: _vm.forms,
                      setForm: _vm.setForm,
                      getBtnText: _vm.getBtnText,
                      loadingBtn: _vm.loadingBtn
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "b-modal",
              {
                ref: "templateModal",
                attrs: {
                  "title-class": "font-weight-bold text-success",
                  centered: "",
                  size: "sm",
                  "no-close-on-backdrop": "",
                  title: "Plantilla " + (_vm.editMode ? "editada" : "guardada"),
                  "hide-header-close": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "modal-footer",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "float-right",
                                attrs: { variant: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push({
                                      name: "approval-templates"
                                    })
                                  }
                                }
                              },
                              [_vm._v(" Ok ")]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c("h5", [
                  _vm._v(
                    "La plantilla se ha " +
                      _vm._s("" + (_vm.editMode ? "editado" : "guardado")) +
                      " correctamente"
                  )
                ])
              ]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }